
const numberOfDecimals = priceWithDot => {
  if (priceWithDot.indexOf('.') === -1) return 0
  if (priceWithDot.substring(-2) === '.0') return 1
  return priceWithDot.split('.')[1].length
}

const getNumOfDecimalsUsed = numOfDecimals => {
  if (numOfDecimals < 2) return 2
  if (numOfDecimals > 4) return 4
  return numOfDecimals
}

export const parsePrice = (price, decPlaces) => {
  if (!price) return '0,00'
  const priceWithDot = (`${price}`).replace(',', '.')
  const numOfDecimalsInPrice = numberOfDecimals(priceWithDot)
  const numOfDecimalsUsed = getNumOfDecimalsUsed(numOfDecimalsInPrice)
  decPlaces = decPlaces || numOfDecimalsUsed
  const floatNum = parseFloat(priceWithDot)
  if (isNaN(floatNum)) return ''
  return (`${parseFloat((`${price}`).replace(',', '.')).toFixed(decPlaces)}`).replace('.', ',')
}
